"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var utils_1 = require("../../../modules/toolbar/utils");
var clamp = function (min, val, max) {
    if (val < min) {
        return min;
    }
    if (val > max) {
        return max;
    }
    return val;
};
exports.MIN_SIZE = 20;
var ResizeDirection = {
    top_right: '',
    bottom_right: '',
    bottom_left: '',
    top_left: ''
};
var ImageResizeBoxControl = /** @class */ (function (_super) {
    __extends(ImageResizeBoxControl, _super);
    function ImageResizeBoxControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._active = false;
        _this._h = 0;
        _this._rafID = 0;
        _this._maxW = 350;
        _this._w = 0;
        _this._x1 = 0;
        _this._x2 = 0;
        _this._y1 = 0;
        _this._y2 = 0;
        _this._ww = 0;
        _this._hh = 0;
        _this._syncSize = function () {
            if (!_this._active) {
                return;
            }
            var direction = _this.props.direction;
            var dx = (_this._x2 - _this._x1) * (/left/.test(direction) ? -1 : 1);
            var aspect = _this._w / _this._h;
            var ww = clamp(exports.MIN_SIZE, _this._w + Math.round(dx), _this._maxW);
            var hh = Math.max(ww / aspect, exports.MIN_SIZE);
            ww = hh * aspect;
            _this._ww = ww;
            _this._hh = hh;
        };
        _this._onMouseDown = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this._end();
            _this._start(e);
        };
        _this._onMouseMove = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this._x2 = e.clientX;
            _this._y2 = e.clientY;
            _this._syncSize();
            _this._rafID = requestAnimationFrame(function () {
                return _this.props.onResizeEnd(_this._ww, _this._hh);
            });
        };
        _this._onMouseUp = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this._x2 = e.clientX;
            _this._y2 = e.clientY;
            _this._end();
        };
        return _this;
    }
    ImageResizeBoxControl.prototype.componentWillUnmount = function () {
        this._end();
    };
    ImageResizeBoxControl.prototype.bindEvent = function () {
        document.addEventListener('mousemove', this._onMouseMove, true);
        document.addEventListener('mouseup', this._onMouseUp, true);
    };
    ImageResizeBoxControl.prototype.unBindEvent = function () {
        document.removeEventListener('mousemove', this._onMouseMove, true);
        document.removeEventListener('mouseup', this._onMouseUp, true);
    };
    ImageResizeBoxControl.prototype.render = function () {
        var _a;
        var direction = this.props.direction;
        var className = classnames_1.default((_a = {
                'syl-image-resize-box-control': true
            },
            _a[direction] = true,
            _a));
        return react_1.default.createElement("span", { className: className, onMouseDown: this._onMouseDown });
    };
    ImageResizeBoxControl.prototype._start = function (e) {
        if (this._active) {
            this._end();
        }
        this._active = true;
        this._maxW = this.props.editorDOM.scrollWidth - 40;
        this._x1 = e.clientX;
        this._y1 = e.clientY;
        this._x2 = this._x1;
        this._y2 = this._y1;
        this._w = this.props.width;
        this._h = this.props.height;
        this._ww = this._w;
        this._hh = this._h;
        this.bindEvent();
    };
    ImageResizeBoxControl.prototype._end = function () {
        if (!this._active) {
            return;
        }
        this._active = false;
        this.unBindEvent();
        this._rafID && cancelAnimationFrame(this._rafID);
        this._rafID = null;
    };
    return ImageResizeBoxControl;
}(react_1.default.PureComponent));
var ImageResizeBox = /** @class */ (function (_super) {
    __extends(ImageResizeBox, _super);
    function ImageResizeBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._id = utils_1.uuid();
        return _this;
    }
    ImageResizeBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, onResizeEnd = _a.onResizeEnd, width = _a.width, height = _a.height;
        var controls = Object.keys(ResizeDirection).map(function (key) {
            return (react_1.default.createElement(ImageResizeBoxControl, __assign({}, _this.props, { config: ResizeDirection[key], direction: key, height: height, key: key, onResizeEnd: onResizeEnd, width: width })));
        });
        return react_1.default.createElement("span", { className: "syl-resizable-container" }, controls);
    };
    return ImageResizeBox;
}(react_1.default.PureComponent));
exports.default = ImageResizeBox;
//# sourceMappingURL=image-resize-box.js.map